import React from "react"
import map from "../../assets/images/map.png"
import vector from "../../assets/images/vector_blue.png"
import Button from "../Button"
import clean from "../../assets/images/clean_icon.png"
import { useTranslation } from "react-i18next"

export default ({ adcivesFor, title }) => {
  const { t } = useTranslation()

  return (
    <div className="top-0 sticky font-[Roboto]">
      <div className="h-auto py-2 pb-5 overflow-auto bg-white">
        <p className="py-4 text-xl font-medium text-center">{t(`${title}`)}</p>
        <ul className="list-disc marker:text-[color:var(--custom-primary)] pl-9 pr-1 text-base">
          {adcivesFor.map((e, idx) => (
            <li className="pb-5" key={idx + 1}>
              {t(e?.desc)}
            </li>
          ))}
        </ul>
      </div>
      <div className="border-1 border-grey overflow-hidden mt-10 w-[100%]">
        <div>
          <div className="relative h-[100%]">
            <img
              className="object-cover min-h-full"
              width="100%"
              src={map}
              alt="map.png"
            />
            <img
              src={vector}
              className="object-cover absolute top-[15%] left-[40%]"
              alt="vector.png"
            />
            <div className="absolute w-full bottom-7">
              <div className="flex justify-center">
                <Button
                  className="font-semibold shadow-[0_25px_40px_-15px_var(--custom-secondary)]"
                  text={t("view-in-map")}
                  color="#fff"
                  width="240px"
                  height="50px"
                  background="var(--custom-secondary)"
                />
              </div>
            </div>
          </div>
        </div>
        <button className="bg-[#E0E2E4] w-full h-[56px] mt-5 rounded-lg flex justify-center items-center gap-2 hover:bg-[#bcbfc0]">
          <img src={clean} alt="" />
          <span className="font-medium text-base text-[#595F62]">
            {t("clean-btn")}
          </span>
        </button>
      </div>
    </div>
  )
}
